import DatasetValue from '@/shared/data/model/DatasetValue';
import { isUndefined } from 'lodash';
import AppConstants from '../model/AppConstants';
import PRICE_FORMAT from '../model/PriceFormat';

export default abstract class Formatter {
  static formatPrice(
    price: DatasetValue,
    priceFormat: PRICE_FORMAT | string = AppConstants.DEFAULT_PRICE_FORMAT,
  ) {
    if (isUndefined(price)) return '';

    // On parse le nombre
    const base = price.toString().replace(',', '.');
    const baseNumber = parseFloat(base);
    if (!Number.isNaN(baseNumber)) {
      const parts = baseNumber.toFixed(2).split('.');
      const [int, decimals] = parts;
      switch (priceFormat) {
        case PRICE_FORMAT.POINTS:
          return `${int} pts`;
        case PRICE_FORMAT.PERCENTAGE:
          return `${int} %`;
        case PRICE_FORMAT.EURO_SPACE:
          return `${int},${decimals} €`;
        case PRICE_FORMAT.EURO:
        default:
          return `${int},${decimals}€`;
      }
    }
    return '';
  }
}
